import {USERTYPE_ANONYMOUS} from 'aa/vue/constants/shared';

$(document).ready(function() {

    function getText(selector) {
        return $(selector).text().replace(/"/g, "").trim();
    }

    // selectors for lock slate / upsell
    let ctaSel = '.video__lock-slate-container a.button[aa-link]';
    let ctaTextSel = ctaSel+' .button__text';
    let titleSel = '.video__lock-slate-text';

    // only if we detect a lock slate element
    let data = $(ctaSel).attr("aa-link");
    if (data) {
        // Get aa-link parameters
        let d = data.split("|");
        let r = d[0];
        let t = d[13];

        // Determine params based on aa-link parameters
        var pageType;
        var upsellType;
        var action;
        if (t == 't') {
            pageType = "upsell_tve";
            upsellType = r;
            action = "trackCta1TVEUpsell"
        } else if(r.indexOf('showtime')!==-1) {
            pageType = "upsell_showtime-bundle";
            upsellType = r;
            action = "trackCTAShowtimeUpsell"
        } else if (t == 'p') {
            pageType = "upsell_paramount-plus";
            upsellType = r;
            action = "trackCta1PPlusUpsell"
        }

        // page load/landing trackState
        let rowHeaderTitle = getText(titleSel);

        let __userType = (CBS.Registry.user.sub_status !== "") ? CBS.Registry.user.sub_status : USERTYPE_ANONYMOUS;
        let __pageType = pageType ?? CBS.Registry.pageType;
        __pageType = (__pageType === 'movies') ? 'movie' : __pageType;
        let isMovie = (__pageType === 'movie') ? true : false;
        let __movieTitle = window.__title ? window.__title : CBS.Registry.MovieTitle;
        let __movieGenre = window.__genre ?? "";
        let __movieId = window.__content_id ?? "";

        // data for page load event
        utag_data = {
            contentBrand: window.__brand ?? "", //TODO
            brandPlatformId: CBS.Registry.brand_platform_desktop_id || '',
            pageType: __pageType,
            upsellType: upsellType,
            rowHeaderTitle: rowHeaderTitle,
            siteHier: 'movies',
            siteEdition: CBS.Registry.siteEdition || '',
            userType: __userType,
            userStatus: CBS.Registry.user.sb || '',
            userRegId: CBS.Registry.user.id || '',
            userProfileId: CBS.Registry.user.profile_id || '',
            userProfileMaster: CBS.Registry.user.userProfileMaster,
            userProfileCategory: CBS.Registry.user.profile_type || '',
            pageViewGuid: window.__page_uuid,
        };

        if (isMovie) {
            utag_data['movieTitle'] = __movieTitle;
            utag_data['movieId'] = __movieId;
            utag_data['movieGenre'] = __movieGenre;
        } else {
            utag_data['showSeriesTitle'] = __movieTitle;
            utag_data['showSeriesId'] = __movieId;
            utag_data['showGenre'] = __movieGenre;
        }

        // cta click
        $(ctaSel).bind("click", function (event) {
            let obj = {
                contentBrand: window.__brand ?? "",
                rowHeaderTitle: getText(titleSel),
                ctaText: getText(ctaTextSel)
            };
            CBS.Promises.Tracking.onLoad(function() {
                try {
                    om.trackAction(action, obj);
                } catch(e) {
                    // prevent crash if omniture not loaded on dev environment
                }
            });
        });
    }

});